import React from "react";

// FilterButton component that displays under column headers
export const FilterButton = React.memo(({ isActive, onClick, columnId }) => {
  return (
    <button
      className="filter-button absolute left-1/2 transform -translate-x-1/2 z-20 hover:bg-gray-100 rounded-full p-1"
      style={{
        top: "20px", // Position under the header text
        marginTop: "2px",
      }}
      onClick={(e) => {
        if (typeof onClick === "function") {
          onClick(e, columnId); // CRITICAL: Must pass both event and columnId
        }
      }}
      title={isActive ? "Clear or modify filters" : "Add filters"}
    >
      {isActive ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99951 20V13.5612C6.99951 13.3532 6.99951 13.2492 6.97909 13.1497C6.96098 13.0615 6.93102 12.9761 6.89003 12.8958C6.84382 12.8054 6.77885 12.7242 6.6489 12.5617L3.35012 8.43826C3.22017 8.27583 3.1552 8.19461 3.10899 8.10417C3.068 8.02393 3.03804 7.93852 3.01993 7.85026C2.99951 7.75078 2.99951 7.64677 2.99951 7.43875V5.6C2.99951 5.03995 2.99951 4.75992 3.1085 4.54601C3.20438 4.35785 3.35736 4.20487 3.54552 4.10899C3.75943 4 4.03946 4 4.59951 4H13.3995C13.9596 4 14.2396 4 14.4535 4.10899C14.6417 4.20487 14.7946 4.35785 14.8905 4.54601C14.9995 4.75992 14.9995 5.03995 14.9995 5.6V7.43875C14.9995 7.64677 14.9995 7.75078 14.9791 7.85026C14.961 7.93852 14.931 8.02393 14.89 8.10417C14.8439 8.19445 14.779 8.27554 14.6496 8.43741L14.6489 8.43826L11.3501 12.5617L11.3488 12.5634C11.2198 12.7248 11.1551 12.8057 11.109 12.8958C11.068 12.9761 11.038 13.0615 11.0199 13.1497C10.9995 13.2492 10.9995 13.3532 10.9995 13.5612V17L6.99951 20Z"
            fill="#2B3674"
          />
          <path
            d="M20.9995 6H18.9995M20.9995 12H15.9995M20.9995 18H15.9995M6.99951 20V13.5612C6.99951 13.3532 6.99951 13.2492 6.97909 13.1497C6.96098 13.0615 6.93102 12.9761 6.89003 12.8958C6.84382 12.8054 6.77885 12.7242 6.6489 12.5617L3.35012 8.43826C3.22017 8.27583 3.1552 8.19461 3.10899 8.10417C3.068 8.02393 3.03804 7.93852 3.01993 7.85026C2.99951 7.75078 2.99951 7.64677 2.99951 7.43875V5.6C2.99951 5.03995 2.99951 4.75992 3.1085 4.54601C3.20438 4.35785 3.35736 4.20487 3.54552 4.10899C3.75943 4 4.03946 4 4.59951 4H13.3995C13.9596 4 14.2396 4 14.4535 4.10899C14.6417 4.20487 14.7946 4.35785 14.8905 4.54601C14.9995 4.75992 14.9995 5.03995 14.9995 5.6V7.43875C14.9995 7.64677 14.9995 7.75078 14.9791 7.85026C14.961 7.93852 14.931 8.02393 14.89 8.10417C14.8439 8.19445 14.779 8.27554 14.6496 8.43741L14.6489 8.43826L11.3501 12.5617L11.3488 12.5634C11.2198 12.7248 11.1551 12.8057 11.109 12.8958C11.068 12.9761 11.038 13.0615 11.0199 13.1497C10.9995 13.2492 10.9995 13.3532 10.9995 13.5612V17L6.99951 20Z"
            stroke="#2B3674"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 4.0013H12.6667M14 8.0013H10.6667M14 12.0013H10.6667M4.66667 13.3346V9.0421C4.66667 8.90344 4.66667 8.8341 4.65305 8.76777C4.64098 8.70897 4.62101 8.65203 4.59368 8.5985C4.56287 8.53823 4.51956 8.4841 4.43293 8.37577L2.23374 5.62681C2.14711 5.51852 2.10379 5.46438 2.07299 5.40408C2.04566 5.35059 2.02569 5.29365 2.01361 5.23481C2 5.16849 2 5.09915 2 4.96047V3.73464C2 3.36127 2 3.17458 2.07266 3.03198C2.13658 2.90654 2.23857 2.80455 2.36401 2.74063C2.50661 2.66797 2.6933 2.66797 3.06667 2.66797H8.93333C9.30673 2.66797 9.4934 2.66797 9.636 2.74063C9.76147 2.80455 9.8634 2.90654 9.92733 3.03198C10 3.17458 10 3.36127 10 3.73464V4.96047C10 5.09915 10 5.16849 9.9864 5.23481C9.97433 5.29365 9.95433 5.35059 9.927 5.40408C9.8962 5.46438 9.85287 5.51852 9.76627 5.62681L7.56707 8.37577C7.48047 8.4841 7.43713 8.53823 7.40633 8.5985C7.379 8.65203 7.359 8.70897 7.34693 8.76777C7.33333 8.8341 7.33333 8.90344 7.33333 9.0421V11.3346L4.66667 13.3346Z"
            stroke="#B2B8CD"
            opacity={0.3}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
});
